const getCurrentDatetime = () => {
    const current = new Date();
    return (current.getFullYear() 
              + '-' 
              + current.getMonth() + 1
              + '-' 
              + current.getDate() 
              + ' ' 
              + current.getHours() 
              + ':'
              + current.getMinutes()
              + ':'
              + current.getSeconds()
              + '.'
              + current.getMilliseconds())
  }

  export default getCurrentDatetime;